window.app.controller('appSliderCtrl', ['$scope', function ($scope) {

    $scope.costMin = 50;
    $scope.costMax = 5000;

    $scope.durationMin = 1; 
    $scope.durationMax = 60;

    $scope.initCalcSlider = () => {
        $(".calc-drag_cost").roundSlider({
            radius: 180,
            width: 8,
            step: 50,
            min: $scope.costMin,
            max: $scope.costMax,
            tooltipFormat: function(e) {
            $scope.user.costVal = e.value
            return e.value + " zł"
            },
            editableTooltip: false,
            circleShape: "half-left",
            handleSize: '+12',
            sliderType: "min-range",
            value: $scope.user.costVal
        });

        $(".calc-drag_dur").roundSlider({
            radius: 180,
            width: 8,
            min: $scope.durationMin,
            max: $scope.durationMax,
            tooltipFormat: function(e) {
            $scope.user.durationVal = e.value
            return e.value + " dni"
            },
            editableTooltip: false,
            circleShape: "half-right",
            handleSize: '+12',
            sliderType: "min-range",
            value: $scope.user.durationVal
        });
    }

    if (0 < $(".range-wrapper").length) {
        document.querySelector('.orange-range').oninput = function() {
            $scope.costVal = this.value;
            $('#costVal').val(this.value);
            let valuePerc = this.value/$scope.costMax * 100;
            this.style.background = `linear-gradient(to right, #EE0A79, #FFB655 ${valuePerc}%, #edeef0 ${valuePerc}%, #edeef0 100%)`;
            $scope.paramChanged = true;
        }

        document.querySelector('.blue-range').oninput = function() {
            $scope.durationVal = this.value;
            $('#durationVal').val(this.value);
            let valuePerc = this.value/$scope.durationMax * 100;
            this.style.background = `linear-gradient(to right, #5B03B2, #07A9F0 ${valuePerc}%, #edeef0 ${valuePerc}%, #edeef0 100%)`;
            $scope.paramChanged = true;
        }
    }

    $scope.setCalcValues = (cost, duration) => {
        $scope.costVal = cost;
        $scope.durationVal = duration;
        $scope.user.costVal = cost;
        $scope.user.durationVal = duration;
    }

    $scope.manageSlider = (costVal, durationVal) => {
        if (!costVal && !durationVal) {
            costVal = +(sessionStorage.hasOwnProperty('orangeRange') ? sessionStorage.getItem('orangeRange') : 2500);
            durationVal = +(sessionStorage.hasOwnProperty('blueRange') ? sessionStorage.getItem('blueRange') : 30);
            $scope.setCalcValues(+(sessionStorage.hasOwnProperty('orangeRange') ? sessionStorage.getItem('orangeRange') : 2500), +(sessionStorage.hasOwnProperty('blueRange') ? sessionStorage.getItem('blueRange') : 30));
        } else {
            $scope.setCalcValues(costVal, durationVal)
        }
        let costPerc = costVal/$scope.costMax * 100;
        let durationPerc = durationVal/$scope.durationMax * 100;
        document.querySelector('.orange-range').style.background = `linear-gradient(to right, #EE0A79, #FFB655 ${costPerc}%, #edeef0 ${costPerc}%, #edeef0 100%)`;
        document.querySelector('.blue-range').style.background = `linear-gradient(to right, #5B03B2, #07A9F0 ${durationPerc}%, #edeef0 ${durationPerc}%, #edeef0 100%)`;
    }

    $scope.checkInputsSize = (newvalue, element, min, max) => {
        newvalue = +newvalue;
        let valuePerc;
        if (newvalue <= min) {
        newvalue = min;
        valuePerc = 0;
        $(element).val( min );
        }
        else if (newvalue >= max) {
        newvalue = max;
        $(element).val( max );
        valuePerc = 100;
        } else {
        valuePerc = newvalue/max * 100;
        }
        return {
        value: newvalue,
        valuePerc: valuePerc
        };
    }

    $scope.checkInputsDataType = (value, middleVal) => {
        var newValue;
        if (/\d/.test(value)) {
        newValue = value.match(/\d+/)[0];
        } else {
        newValue = middleVal;
        }
        return newValue;
    }

    $('#costVal').change(function() {
        let newValue = $scope.checkInputsDataType($(this).val(), 2500);
        let newData = $scope.checkInputsSize(newValue, '#costVal', $scope.costMin, $scope.costMax);
        newValue = newData.value;
        $('.orange-range').val(newValue);
        $scope.costVal = newValue;        
        $(this).val( newValue );
        $scope.user.costVal = newValue;
        let valuePerc = newData.valuePerc;
        document.querySelector('.orange-range').style.background = `linear-gradient(to right, #FF0062, #FFBE05 ${valuePerc}%, #EEEEEE ${valuePerc}%, #EEEEEE 100%)`;
        $scope.paramChanged = true;
    });

    $('#durationVal').change(function() {
        let newValue = $scope.checkInputsDataType($(this).val(), 30);
        let newData = $scope.checkInputsSize(newValue, '#durationVal', $scope.durationMin, $scope.durationMax);
        newValue = newData.value;
        $('.blue-range').val(newValue);   
        $scope.user.durationVal = newValue;     
        $scope.durationVal = newValue; 
        $(this).val( newValue );
        let valuePerc = newData.valuePerc;
        document.querySelector('.blue-range').style.background = `linear-gradient(to right, #6200AA, #00AAEF ${valuePerc}%, #EEEEEE ${valuePerc}%, #EEEEEE 100%)`;
        $scope.paramChanged = true;
    });

    // $scope.$on('passAppParams', function(event, data){
    //     $scope.user.costVal = data.costVal,
    //     $scope.user.durationVal = data.durationVal,
    //     $scope.initCalcSlider()
    //   })
}]);


// WEBPACK FOOTER //
// src/js/controllers/singleApplication/appSliderCtrl.js